export const boardCRMTour = {
  key: "boardCRM",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-crm-customers"]',
      content: t("Tour_BoardCRM_Contacts"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-crm-addcontact"]',
      content: t("Tour_BoardCRM_AddContact"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-crm-filter"]',
      content: t("Tour_BoardCRM_Filter"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-crm-customerslist"]',
      content: t("Tour_BoardCRM_Deal"),
      placement: "top",
    },
    {
      target: '[data-tour="board-crm-categories"]',
      content: t("Tour_BoardCRM_Pipeline"),
      placement: "top",
    },
    {
      target: '[data-tour="board-crm-dashboard"]',
      content: t("Tour_BoardCRM_Filter"),
      placement: "top",
    },
    {
      target: '[data-tour="board-crm-pipeline"]',
      content: t("Tour_BoardCRM_Deal"),
      placement: "top",
    },
  ],
};
